module.exports = __webpack_public_path__ + "static/media/joyable3.94e16f60.jpg";